/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_UnavailableInputs */

const en_us2_chat_unavailable = /** @type {(inputs: Chat_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The trainer is unavailable right now.`)
};

const pt_br2_chat_unavailable = /** @type {(inputs: Chat_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O personal está indisponível agora.`)
};

const es_419_chat_unavailable = /** @type {(inputs: Chat_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El entrenador no está disponible ahora.`)
};

const pt_pt2_chat_unavailable = /** @type {(inputs: Chat_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O treinador está indisponível neste momento.`)
};

const fr_fr2_chat_unavailable = /** @type {(inputs: Chat_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le coach n'est pas disponible pour le moment.`)
};

const de_de2_chat_unavailable = /** @type {(inputs: Chat_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Coach ist gerade nicht erreichbar.`)
};

const it_it2_chat_unavailable = /** @type {(inputs: Chat_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il coach non è disponibile in questo momento.`)
};

/**
* | output |
* | --- |
* | "The trainer is unavailable right now." |
*
* @param {Chat_UnavailableInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const chat_unavailable = /** @type {((inputs?: Chat_UnavailableInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_UnavailableInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_chat_unavailable(inputs)
	if (locale === "es-419") return es_419_chat_unavailable(inputs)
	if (locale === "pt-PT") return pt_pt2_chat_unavailable(inputs)
	if (locale === "fr-FR") return fr_fr2_chat_unavailable(inputs)
	if (locale === "de-DE") return de_de2_chat_unavailable(inputs)
	if (locale === "it-IT") return it_it2_chat_unavailable(inputs)
	return en_us2_chat_unavailable(inputs)
});
export { chat_unavailable as "chat.unavailable" }